import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Woman/Woman.css";

export default function Bones() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState(sessionStorage.getItem("searchTerm") || "");
  const [allGraves, setAllGraves] = useState([]);
  const [error, setError] = useState("");

  // الكروت الاستاتيك
  const staticGraves = [
    {
      _id: "67ab74f2812cd99438df7ae1",
      number: "مقابر العظام مرحلة أولى من 294-298",
      status: "غير متاحة",
    },
    {
      _id: "67ab75cc812cd99438df829e",
      number: "مقابر العظام المرحلة الثانية",
      status: "غير متاحة",
    },
  ];

  // ✅ إرسال GET request لتحديث حالات المقابر عند دخول الصفحة
  useEffect(() => {
    const updateGraveStatuses = async () => {
      try {
        await fetch("https://cemetery-management.vercel.app/api/graves/update-statuses");
        console.log("✅ Grave statuses updated successfully");
      } catch (error) {
        console.error("❌ Error updating grave statuses:", error);
      }
    };

    updateGraveStatuses();
  }, []); // يتم التنفيذ مرة واحدة عند تحميل الصفحة

  // جلب المقابر من الـ API بناءً على الاسم المدخل
  const fetchGravesByName = async (name) => {
    try {
      const response = await fetch(`https://cemetery-management.vercel.app/api/graves/bone`);
      const data = await response.json();
      const matchedGraves = data.filter((grave) =>
        grave.buriedPersons.some((person) => person.name.includes(name))
      );

      if (matchedGraves.length > 0) {
        const gravesWithDetails = matchedGraves.map((grave) => {
          const staticGrave = staticGraves.find((staticGrave) => staticGrave._id === grave._id);
          return staticGrave ? { ...staticGrave, buriedPersons: grave.buriedPersons } : null;
        });

        const validGraves = gravesWithDetails.filter((grave) => grave !== null);
        setAllGraves(validGraves);
        setError("");
      } else {
        setAllGraves([]);
        setError("لا توجد نتائج مطابقة للبحث.");
      }
    } catch (error) {
      console.error("Error fetching graves:", error);
      setError("حدث خطأ في الاتصال.");
    }
  };

  // تحديث قيمة البحث في sessionStorage
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    sessionStorage.setItem("searchTerm", value);
  };

  // البحث حسب الاسم عند التغيير
  useEffect(() => {
    if (searchTerm === "") {
      setAllGraves(staticGraves);
      setError("");
    } else {
      fetchGravesByName(searchTerm);
    }
  }, [searchTerm]);

  const goToGraveDetails = (graveId) => {
    navigate(`/grave-details-user/${graveId}`);
  };

  return (
    <div className="woman-container">
      {/* Input for Searching */}
      <input
        type="text"
        placeholder="ابحث عن اسم المتوفي...."
        value={searchTerm}
        onChange={handleSearchChange}
        className="search-input"
      />

      {error && <p className="no-results-message">{error}</p>}

      {allGraves.length > 0 ? (
        allGraves.map((grave) => (
          <div
            key={grave._id}
            className={`grave-card ${grave.status === "متاحة" ? "available" : "not-available"}`}
          >
            <h2>{grave.number}</h2>
            <p>الحالة: {grave.status}</p>
            <button className="show-more-btn" onClick={() => goToGraveDetails(grave._id)}>
              عرض المزيد
            </button>
          </div>
        ))
      ) : (
        <p className="no-results-message">لا توجد نتائج مطابقة للبحث.</p>
      )}
    </div>
  );
}
